import { getViewKey } from '@/api/account';

const imgStore = {
    namespaced:true,
    state:{
        vmUrl:'',
        loadUrl:'',
        vmToken:''
    },

    mutations:{

        VALUE_SET (state,payload){
            for(let key in payload){
                state[key] = payload[key];
            }
        }

    },

    actions:{

        async act_getStore({commit,state}){
            if(!state.vmToken){
                var unFmdat = await getViewKey();
                commit('VALUE_SET',{ vmUrl: unFmdat.imagePreUrl});
                commit('VALUE_SET',{ loadUrl: unFmdat.download});
                commit('VALUE_SET',{ vmToken: unFmdat.token});
            };

            return state;

        }

    },

}

export default imgStore;



// WEBPACK FOOTER //
// ./src/store/modules/imgStore.js